{
  "2025-08-01": {
    "text": "Rendez-vous",
    "place": "La Jaminade Grasse",
    "link": "https://www.paysdegrassetourisme.fr/fete-du-jasmin-6484609/"
  },
  "2025-08-02": {
    "text": "Rendez-vous",
    "place": "La Jaminade Grasse",
    "link": "https://www.paysdegrassetourisme.fr/fete-du-jasmin-6484609/"
  },
  "2025-08-03": {
    "text": "Rendez-vous",
    "place": "La Jaminade Grasse",
    "link": "https://www.paysdegrassetourisme.fr/fete-du-jasmin-6484609/"
  }
}